import React, { useCallback } from 'react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { FormControl, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { ClusterPickerProps, ClusterPickerSchema } from './schema';
import { useAsync } from 'react-use';
import { useApi } from '@backstage/core-plugin-api';
import { customArgoCDApiRef } from '../../../../apis/ArgoCDApi';

const ClusterPicker = (props: ClusterPickerProps) => {
  const {
    onChange,
    required,
    schema: { title = 'Cluster' },
    rawErrors,
    formData,
    idSchema,
  } = props;

  const argocdApi = useApi(customArgoCDApiRef);

  const { value: clusters, loading } = useAsync(() => argocdApi.listClusters());

  const clusterRefs = clusters?.items.map(c => c.name);

  const onSelect = useCallback(
    (_: any, value: string | null) => {
      onChange(value ?? undefined);
    },
    [onChange],
  );

  return (
    <FormControl required={required} error={rawErrors?.length > 0 && !formData}>
      <Autocomplete
        id={idSchema?.$id}
        value={(formData as string) || ''}
        loading={loading}
        onChange={onSelect}
        options={clusterRefs || []}
        autoSelect
        renderInput={params => (
          <TextField
            {...params}
            label={title}
            variant="outlined"
            required={required}
            InputProps={params.InputProps}
          />
        )}
      />
    </FormControl>
  );
};

export const ClusterPickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ClusterPicker',
    component: ClusterPicker,
    schema: ClusterPickerSchema,
  }),
);
